export const SET_CHANNELS = 'SET_CHANNELS';
export const setChannelsAction = (channels) => ({
  type: SET_CHANNELS,
  payload: channels,
});
